import Browser from '../../../../../services/Browser'
import { GRAY, PRIMARY_COLOR } from '../../../../../styles/colors.style'
import { borderRadius } from '../../../../../styles/reusable.style'

export const selectStyles = {
	menuPortal: (base) => ({ ...base, zIndex: 4 }),
	option: (base, state) => ({
		...base,
		color: state.isFocused ? 'white' : GRAY,
		fontSize: '16px',
		background: state.isFocused ? PRIMARY_COLOR : 'white',
	}),
	control: (base, state) => ({
		...base,
		outline: 'none',
		fontSize: '16px',
		padding: '0',
		background: state.isDisabled ? '#F6F7F9' : 'white',
		border: `1px solid ${
			state.isFocused ? PRIMARY_COLOR : '#E0E0E0'
		} !important`,
		borderRadius: borderRadius,
		color: `${GRAY}`,
		height: '42px !important',
	}),
	valueContainer: (base, state) => ({
		...base,
		overflow: 'hidden',
	}),
	menu: (base, state) => ({
		...base,
		marginTop: '0',
	}),
	singleValue: (base, state) => ({
		color: GRAY,
		fontSize: '16px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		maxWidth: Browser.isFirefox() ? 'calc(85% - 19px)' : '85%',
	}),
	dropdownIndicator: (base, state) => ({
		...base,
		padding: '1rem',
	}),
}
